import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import Course from '../components/course';
import MetaTags from '../common-components/MetaTags';

class OurCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
      // document.title = "Our Course - Learn Quran Easily";
      // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1800); // Simulate a 3-second loading delay
  }


  render() {
    const blogData = [
      {
        image: "img/blog-1.jpg",
        date: "01 Jan 2045",
        author: "Admin",
        authorLink: "#",
        commentLink: "#",
        comments: 12,
        title: "Importance of ‘Pillar’ of Islam",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
        link: "#",
        bookmarkLink: "#"
      },
      {
        image: "img/blog-2.jpg",
        date: "01 Jan 2045",
        author: "Admin",
        authorLink: "#",
        commentLink: "#",
        comments: 12,
        title: "How to get closer to Allah",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
        link: "#",
        bookmarkLink: "#"
      },
      {
        image: "img/blog-3.jpg",
        date: "01 Jan 2045",
        author: "Admin",
        authorLink: "#",
        commentLink: "#",
        comments: 12,
        title: "Importance of Hajj in Islam",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
        link: "#",
        bookmarkLink: "#"
      }
    ];
    const breadcrumbs = [
        { label: 'Home', href: '/home', isCurrentPage: false },
        // { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Our Courses', href: '#', isCurrentPage: true },
      ];

    return <>
    <MetaTags
      title="Our Courses - Learn Quran Easily"
      description="Explore our wide range of Quran and Islamic courses designed for kids and adults. Learn at your pace with expert teachers at Learn Quran Easily."
      keywords="Quran Courses, Islamic Classes, Online Quran Learning, Learn Quran Easily Courses, Tajweed, Tafsir, Arabic, LQE Courses"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/our-course"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Our Courses" breadcrumbs={breadcrumbs} />
          <Course blogData={blogData} />
        </>}
    </>
  }
}

export default OurCourse;
